import React from 'react';

import {
	ROOT,
	ADMIN,
	CONTRACTOR,
	PROVIDER,
	USER,
} from 'constants/roles.constant';

const mgmtRoute = [
	{
		key: 'management.contractors',
		path: `/businesses/contractors`,
		component: React.lazy(() => import('views/businesses/Businesses')),
		authority: [ROOT, ADMIN, PROVIDER],
	},
	{
		key: 'management.contractors',
		path: `/businesses/contractors/details`,
		component: React.lazy(() => import('views/businesses/BusinessDetail')),
		authority: [ROOT, ADMIN, PROVIDER],
		meta: {
			headerContainer: false,
			footer: true,
		},
	},
	{
		key: 'management.providers',
		path: `/businesses/providers`,
		component: React.lazy(() => import('views/businesses/Businesses')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
	{
		key: 'management.providers',
		path: `/businesses/providers/details`,
		component: React.lazy(() => import('views/businesses/BusinessDetail')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
		meta: {
			header: 'Detalles de Proveedor',
			headerContainer: true,
		},
	},
	{
		key: 'management.employees',
		path: `/employees`,
		component: React.lazy(() => import('views/pages/UnderConstruction')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
	{
		key: 'management.subscriptions',
		path: `/subscriptions`,
		component: React.lazy(() => import('views/pages/UnderConstruction')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
	{
		key: 'management.transactions',
		path: `/transactions`,
		component: React.lazy(() => import('views/pages/UnderConstruction')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
	},
	{
		key: 'management.settings',
		path: `/settings/:tab`,
		component: React.lazy(() => import('views/config/Settings')),
		authority: [ROOT, ADMIN, CONTRACTOR, PROVIDER, USER],
		meta: {
			pageContainerType: 'default',
			header: 'Ajustes',
			headerContainer: true,
			footer: true,
		},
	},
];

export default mgmtRoute;
